/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MethodologyResponse,
  UpsertMethodologyRequest,
  V1MethodologiesListError,
  V1MethodologiesUpdateError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Methodology<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Methodology
   * @name V1MethodologiesList
   * @request GET:/api/v1/methodologies
   * @secure
   * @response `200` `(MethodologyResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1MethodologiesList = (
    query?: {
      methodologyIds?: string[];
      /**
       * If true return only methodologies, where IsCurrent is true. If false return all methodologies regardless of IsCurrent is true or false.
       * @default false
       */
      onlyCurrent?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<MethodologyResponse[], V1MethodologiesListError>({
      path: `/api/v1/methodologies`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Methodology
   * @name V1MethodologiesUpdate
   * @summary Updates (if Id is set), creates (if Id is not set) and deletes (exists in DB but not in request and is unused) methodologies.
   * @request PUT:/api/v1/methodologies
   * @secure
   * @response `200` `(MethodologyResponse)[]` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1MethodologiesUpdate = (data: UpsertMethodologyRequest[], params: RequestParams = {}) =>
    this.http.request<MethodologyResponse[], V1MethodologiesUpdateError>({
      path: `/api/v1/methodologies`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
